import store from 'vuex-store/index'
import router from '@/router'
import { showNotice } from '@/utils/tool'
import i18n from '@/i18n'
import Vue from 'vue'
import { getCurrentTheme } from '@/config/themeConfig'

/**
 * 個資是否已填齊（必填欄位 + 聯絡方式）
 * 個資頁、登入/註冊導向、入金前檢查共用同一份欄位判斷。
 * @param {Object} memberInfo store 的 memberInfo
 * @returns {boolean}
 */
export function isPersonalDataComplete(memberInfo) {
  if (!memberInfo) return false

  // theme_blue 不需羅馬拼音
  const requiredFields = getCurrentTheme() === 'theme_blue'
    ? ['name', 'address', 'birthday']
    : ['romanization', 'name', 'address', 'birthday']

  const hasAllRequired = requiredFields.every(field => {
    const value = memberInfo[field]
    return value && value.toString().trim() !== ''
  })

  const hasContact = (memberInfo.phone && memberInfo.phone.trim() !== '') ||
    (memberInfo.email && memberInfo.email.trim() !== '')

  return hasAllRequired && hasContact
}

/**
 * 是否需要補個資（登入/註冊導向與個資頁守衛共用同一份判斷，避免兩邊標準不一致）
 * - 未登入 / 無會員資料 → false
 * - 後台個資開關關閉（register_need_member_info === 0）→ false（TI 站：要 KYC 但不要個資）
 * - 個資已填齊 → false
 * 註：是否要求個資已與 KYC 開關（enable_kyc_certification）脫鉤，改吃獨立開關
 *     register_need_member_info（後端預設 1，維持現行行為）。
 * @param {Object} memberInfo store 的 memberInfo
 * @param {Object} permissionInfo store 的 permissionInfo
 * @returns {boolean}
 */
export function needPersonalData(memberInfo, permissionInfo) {
  if (!memberInfo) return false
  if (!permissionInfo || permissionInfo.register_need_member_info === 0) return false

  return !isPersonalDataComplete(memberInfo)
}

export function login(data, redirectPath) {
  store.dispatch('SetUserData', data)
  store.dispatch('UpdateCsUrl')
  // socket重連
  Vue.prototype.$socket.reinit()

  if (redirectPath == null) {
    return
  }

  if (redirectPath.indexOf('match') > -1) {
    window.location.href = redirectPath
    return
  }

  if (data.member_info.password_valid === 0) {
    // 強制改密碼
    showNotice(i18n.t('Bao.reset_password_notice'))
    router.push({ path: '/user/reset' })
  } else {
    // 登入
    if (redirectPath === undefined) {
      redirectPath = 'index'
    }
    router.push({ path: '/' + redirectPath }).catch(() => {
    })
  }

  if (data.member_info) {
    store.commit('SET_GOLD_INFO', data.gold_info)
    store.commit('SET_GOLD_TOTAL', data)
    store.commit('SET_MAIN_GOLD', data)
    store.commit('SET_BONUS_GOLD', data)
    store.commit('SET_MAIN_POINT', data)
    store.commit('SET_MAIN_TURNOVER', data)
    store.commit('SET_COMMISSION_GOLD', data)
  }

  if (data.member_info.main_points !== undefined && data.member_info.bonus_points !== undefined) {
    store.commit('SET_POINTS', data.member_info)
  }
}

export function logout(msg) {
  // 呼叫app
  try {
    window.webkit.messageHandlers.openLogin.postMessage(null)
    return
  } catch (e) {
    // console.error(e)
  }
  try {
    window.JSInterface.openLogin()
    return
  } catch (e) {
    // console.log(e)
  }

  router.push({ path: '/' }).catch(() => {
  })
  if (msg === undefined) {
    msg = i18n.t('Bao.has_logout')
  }
  store.dispatch('LogOut').then(() => {
    store.dispatch('UpdateCsUrl')
    const iframeBottom = document.querySelector('.iframe-overlay')
    try {
      // eslint-disable-next-line
      if (WebviewInterface !== undefined) {
        // eslint-disable-next-line
        WebviewInterface.logout()
      }
    } catch (e) {
      console.log('WebviewInterface', e)
      store.commit('SET_GAME_URL', '')
      if (iframeBottom) {
        iframeBottom.style.display = 'none'
      }
    }
    // socket斷線
    Vue.prototype.$socket.close()
    showNotice(msg)
  })
}
